export default "__VITE_ASSET__rulgtW5v__"